<template>
  <div class="dashboard-block">
    <h2>Payment Details</h2>

    <ul class="item-detail item-detail-simple">
      <li>
        <router-link v-if="userManagesOwnPayment" :to="{ name: `${ $route.name }.payment-details`, params: { id: user.id } }" active-class="">
          <div class="row">
            <div class="col-xs-8" v-if="userIsTalent">
              <h3 class="has-sub">My Payment Details</h3>
              <p class="sub-text">Let us know how and where you want to be paid.</p>
            </div>
            <div class="col-xs-8" v-else-if="userIsManager">
              <h3 class="has-sub">Default Payment Details</h3>
              <p class="sub-text">Set default payment details for all {{ $starLabelPlural }} under your management..</p>
            </div>
            <div class="col-xs-4">
              <div class="actions pull-right">
                <span class="btn btn-info">
                  <i class="fa fa-pencil"></i>
                </span>
              </div>
            </div>
          </div>
        </router-link>
        <div v-else class="row">
          <div class="col-xs-8">
            <h3 v-if="!userManagesOwnPayment" class="sub-text">Your payments are handled through your manager</h3>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { helpers } from 'mixins/users'

export default {
  mixins: [helpers],

  computed: {
    ...mapState('user', ['user']),

    userManagesOwnPayment () {
      if (this.userIsManager || (this.userIsTalent && (!this.user.payment_details || this.user.payment_details.allow_talent_change))) {
        return true
      }
      return false
    }
  }
}
</script>
